import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useLocation } from "react-router-dom";
import { MdDashboard, MdKeyboardArrowDown } from "react-icons/md";
import { FaAward, FaWallet } from "react-icons/fa";
import { IoNewspaperOutline } from "react-icons/io5";
import { BsGlobe } from "react-icons/bs";
import { SiHelpscout } from "react-icons/si";
import { LuLogOut } from "react-icons/lu";
import Layout from "./Layout";
import { useUser } from "../../../hooks/use-user";
import { FaArtstation } from "react-icons/fa6";
import { GoDotFill } from "react-icons/go";
import ReferAndEarn from "./ReferAndEarn";
const Sidebar = () => {
  const { data: user } = useUser();
  const navigate = useNavigate();
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [nowOpen, setNowOpen] = useState(false);
  const [t, i18n] = useTranslation();
  const isContestValid = user?.isContestValid === true;

  const toggleSidebar = () => {
    setIsSidebarOpen(!isSidebarOpen);
  };

  const toggleDropdown = () => {
    setNowOpen(!nowOpen);
  };

  const closeSidebar = () => {
    setIsSidebarOpen(false);
  };

  const changeLanguage = (lang) => {
    i18n.changeLanguage(lang);
  };

  const getLinkClass = (path) => {
    return location.pathname === path
      ? "flex items-center p-2 text-purple bg-purple-100 rounded-lg dark:text-purple-400 group"
      : "flex items-center p-2 text-gray-900 rounded-lg dark:text-black group";
  };

  return (
    <>
      <button
        onClick={toggleSidebar}
        className="p-2 mt-2 ms-3 text-sm text-gray-500 rounded-lg sm:hidden flex"
      >
        <svg
          className="w-8 h-8"
          aria-hidden="true"
          fill="currentColor"
          viewBox="0 0 20 20"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            clipRule="evenodd"
            fillRule="evenodd"
            d="M2 4.75A.75.75 0 012.75 4h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 4.75zm0 10.5a.75.75 0 01.75-.75h7.5a.75.75 0 010 1.5h-7.5a.75.75 0 01-.75-.75zM2 10a.75.75 0 01.75-.75h14.5a.75.75 0 010 1.5H2.75A.75.75 0 012 10z"
          ></path>
        </svg>
      </button>

      <aside
        id="sidebar-multi-level-sidebar"
        className={`fixed top-20 left-0 z-40 w-64 h-screen transition-transform ${isSidebarOpen ? "translate-x-0" : "-translate-x-full sm:translate-x-0"
          }`}
        aria-label="Sidebar"
      >
        <div className="h-full px-3 py-4 overflow-y-auto bg-gray-50 dark:bg-white-800 ">
          <button
            onClick={closeSidebar}
            className="absolute top-2 right-2 p-2 text-gray-500 rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 sm:hidden"
          >
            <svg
              className="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
          <ul className="space-y-2 font-medium font-oswald font-bold p-4">
            <li>
              <Link to="/dash/home" className={getLinkClass("/dash/home")}>
                <MdDashboard className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 text-lg font-semibold">Dashboard</span>
              </Link>
            </li>
            <hr />
            {user?.planName !== "TEST" && (
              <>
                <li>
                  <Link
                    to="/dash/quize"
                    className={getLinkClass("/dash/quize")}
                  >
                    <FaArtstation className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                    <span className="ms-3 text-lg font-semibold"> Quiz</span>
                  </Link>
                </li>
                <hr />
              </>
            )}
            <li>
              <Link to="/dash/plan" className={getLinkClass("/dash/plan")}>
                <IoNewspaperOutline className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 text-lg font-semibold">Course</span>
              </Link>
            </li>
            {isContestValid && (
              <>
                <hr />
                <li>
                  <Link
                    to="/dash/contest"
                    className={getLinkClass("/dash/contest")}
                  >
                    <FaAward className="w-7 h-7 text-bgBlue transition duration-75" />
                    <span className="ms-3 text-lg font-semibold">Contest</span>
                  </Link>
                </li>
              </>
            )}

            {/* <li>
              <Link
                to="/dash/contest"
                className={getLinkClass("/dash/contest")}
              >
                <FaAward className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 text-lg font-semibold">Contest</span>
              </Link>
            </li> */}
            <hr />
            <li>
              <Link to="/dash/wallet" className={getLinkClass("/dash/wallet")}>
                <FaWallet className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 text-lg font-semibold">Wallet</span>
              </Link>
            </li>
            <hr />
            <ReferAndEarn />

            <li onClick={toggleDropdown}>
              <div
                className={`flex items-center justify-between p-2 rounded-lg cursor-pointer ${nowOpen ? "bg-gray-100" : ""
                  }`}
              >
                <div className="flex items-center">
                  <BsGlobe className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                  <span className="ms-3 text-lg font-semibold">Language</span>
                </div>
                <MdKeyboardArrowDown className="text-end" size={24} />
              </div>
              <ul
                id="dropdown-example"
                className={`space-y-2 font-medium flex flex-col items-center justify-center mt-2 text-end ${nowOpen ? "" : "hidden"
                  }`}
              >
                <li
                  className="flex items-center  w-full  text-bgBlue font-bold text-lg pl-10 cursor-pointer"
                  onClick={() => changeLanguage("hi")}
                >
                  <GoDotFill className="text-purple mr-2" size={25} /> हिन्दी
                </li>
                <li
                  className="flex items-center  w-full  text-bgBlue font-bold text-lg pl-10 cursor-pointer"
                  onClick={() => changeLanguage("en")}
                >
                  <GoDotFill className="text-purple mr-2" size={25} /> English
                </li>
              </ul>
            </li>
            <hr />
            <li>
              <Link className={getLinkClass("/support")}>
                <SiHelpscout className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 text-lg font-semibold">Support</span>
              </Link>
            </li>
            <hr />
            <li
              onClick={() => {
                localStorage.removeItem("token");
                // Notify other tabs
                const bc = new BroadcastChannel("auth");
                bc.postMessage("logout");
                navigate("/login");
              }}
            >
              <Link className={getLinkClass("/logout")}>
                <LuLogOut className="w-7 h-7 text-bgBlue transition duration-75 dark:text-gray-400 group-hover:text-gray-900 dark:group-hover:text-black" />
                <span className="ms-3 text-lg font-semibold">Logout</span>
              </Link>
            </li>
            <hr />
          </ul>
        </div>
      </aside>

      <div className="sm:ml-64 lg:py-8 sm:h-screen ">
        <Layout />
        {/* {showModal && (
          <>
            <div className="justify-center items-center flex overflow-x-hidden overflow-y-auto fixed inset-0 z-50 outline-none focus:outline-none">
              <div className="relative w-80 my-6 mx-auto max-w-sm bg-bgBlue rounded-3xl">
                <div className="rounded-3xl shadow-lg relative flex flex-col w-full bg-bgBlue">
                  <div className="flex items-start justify-between p-4">
                    <h3 className="text-xl font-semibold text-bgBlue">
                      {t("Select Language")}
                    </h3>
                    <button
                      className="text-white float-right leading-none font-semibold outline-none focus:outline-none"
                      onClick={() => setShowModal(false)}
                    >
                      <span className="text-white h-6 w-6 text-2xl outline-none focus:outline-none">
                        ×
                      </span>
                    </button>
                  </div>
                  <div className="relative p-6 flex-auto">
                    <div
                      className="mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem]"
                      onClick={() => changeLanguage("en")}
                    >
                      <input
                        className="relative float-left mt-[0.15rem] -ml-[1.5rem] mr-2 h-5 w-5 cursor-pointer appearance-none rounded-full border-2 border-solid border-neutral-300"
                        type="radio"
                        name="language"
                        id="en"
                      />
                      <label
                        className="inline-block pl-[0.15rem] text-white"
                        htmlFor="en"
                      >
                        English
                      </label>
                    </div>

                    <div
                      className="mb-[0.125rem] block min-h-[1.5rem] pl-[1.5rem]"
                      onClick={() => changeLanguage("hi")}
                    >
                      <input
                        className="relative float-left mt-[0.15rem] -ml-[1.5rem] mr-2 h-5 w-5 cursor-pointer appearance-none rounded-full border-2 border-solid border-neutral-300"
                        type="radio"
                        name="language"
                        id="hi"
                      />
                      <label
                        className="inline-block pl-[0.15rem] text-white"
                        htmlFor="hi"
                      >
                        Hindi
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="opacity-25 fixed inset-0 z-40 bg-black"></div>
          </>
        )} */}
      </div>
    </>
  );
};

export default Sidebar;
